import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';

@Component({
    selector: 'app-popup-image',
    templateUrl: './popup-image.component.html',
    styleUrls: ['./popup-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupImageComponent implements OnInit {

    @Input() imageId: string;
    @Input() indicationId: string;
    @Input() textSize: string;
    @Input() imagePath: string;
    imageBytes = '';
    description: string;
    loadingImage = true;

    constructor(private fileRestService: FileRestService, private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.imagePath ? this.loadImageFromPath(this.imagePath) : this.loadImage(this.imageId, this.indicationId);
    }

    loadImage(imageId: string, indicationId: string): void {
        this.fileRestService.getPopupMultimediaImage(imageId, indicationId).subscribe(response => {
            let binary = '';
            const bytes = new Uint8Array(response);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            const base64String = btoa(binary);
            this.imageBytes = 'data:image/png;base64,' + base64String;
            this.loadingImage = false;
            this.cdr.detectChanges();
        });
    }

    loadImageFromPath(imagePath: string): void {
        this.fileRestService.getSingleResource(imagePath).subscribe(response => {
            let binary = '';
            const bytes = new Uint8Array(response);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            const base64String = btoa(binary);
            this.imageBytes = 'data:image/png;base64,' + base64String;
            this.loadingImage = false;
            this.cdr.detectChanges();
        });
    }
}


